export default "__VITE_ASSET__DV5Y_l1R__"